import { CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { MainPresenter } from 'src/main/Main.presenter'
import { validarChaveNFe } from 'src/utils/nfe-utils'
import SerproKeys from './serpro.keys'
import SerproScope, { HeaderScope } from './serpro.scopes'
import serproService from './serpro.service'

const LOG = Logger.get('SerproPresenter')

export class SerproPresenter extends CubePresenter<MainPresenter, SerproScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, SerproPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new SerproScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new SerproKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        keys.parentSlot(this.scope)

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.action(this.handleFind)
    }

    private async handleFind() {
        if (!validarChaveNFe(this.scope.chaveNfeSelected)) {
            this.alert('error', 'Chave inválida', 'A chave da NFe informada é inválida. Verifique e tente novamente.')
            return
        }
        try {
            this.scope.waiting = new WaitingScope()

            const nfe = await serproService.fetchNfe(this.scope.chaveNfeSelected)
            this.scope.nfe = nfe
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }
}

export default SerproPresenter
